import classNames from "classnames";
import { FilterContext } from "components/filters/FilterContext";
import moment from "moment";
import React, { useContext } from "react";
import { useViewport } from "utilities/hookutils";
import { flattenPeriodList, getQuartersList } from "../periodfilter/timeutils";
import { getPageNumbers } from "utilities/paginationUtils";

export const QuarterNavigationFilter = () => {
  const filterContext = useContext(FilterContext);
  const quarterFilter = filterContext.getValue("quarter");
  const quarter = quarterFilter.quarter;
  const viewport = useViewport();

  let pagesBeforeAndAfterCenterPoint = 3;
  switch (viewport) {
    case "mobile":
      pagesBeforeAndAfterCenterPoint = 1;
      break;
    case "desktopSmall":
      pagesBeforeAndAfterCenterPoint = 3;
      break;
    default:
      pagesBeforeAndAfterCenterPoint = 5;
      break;
  }

  const onGoToQuarter = (quarter: moment.Moment) => {
    filterContext.setValue("quarter", { quarter });
  }

  if (quarter == null) {
    return null;
  }

  const list = [0, ...flattenPeriodList(getQuartersList())];
  const currentTime = quarter.valueOf();
  const currentIndex = list.findIndex(x => x >= currentTime);
  const entries = getPageNumbers(currentIndex, list.length - 1, pagesBeforeAndAfterCenterPoint);
  const index = entries.findIndex(x => x === currentIndex);
  const quarters = entries.map(x => moment.utc(list[x]));

  return <div className="pagination_small">
    <div className="pages">
      {quarters.map((m, idx) => {
        const numberClasses = classNames({
          current: idx === index,
        });

        return <div
          key={`${m.year()}-${m.quarter()}`}
          onClick={() => { onGoToQuarter(m) }}
          className={numberClasses}>
          {m.format("MMM YY")}
        </div>;
      })}
    </div>
  </div>
};
